// src/Views/Signout.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// We are bypassing useAuth for the action to ensure it works directly
import { getAuth, signOut } from 'firebase/auth'; 
import { Icon } from '@iconify/react';
import './Signout.css';

const Signout = () => {
    const navigate = useNavigate();
    const [isLoggingOut, setIsLoggingOut] = useState(false);

    const handleConfirm = async () => {
        setIsLoggingOut(true);
        try {
            // DIRECT OVERRIDE: Calling Firebase directly
            const auth = getAuth();
            await signOut(auth);

            console.log("✅ Session Terminated.");
            
            // Force redirect to login
            navigate('/signin', { replace: true });
            
        } catch (error) {
            console.error("Logout failed", error);
            setIsLoggingOut(false);
            // Fallback: If firebase fails, force the user out of the UI anyway
            // navigate('/signin', { replace: true }); 
        }
    };

    const handleCancel = () => {
        navigate(-1);
    };

    return (
        <div className="signout">
            {/* Background Atmosphere */}
            <div className="signout__bg">
                <div className="signout__glow signout__glow--red" />
            </div>
            
            <div className="signout__card">
                <div className="signout__icon-wrap">
                    <Icon icon="solar:logout-3-bold" className="signout__icon" />
                </div>

                <h1 className="signout__title">Terminate Session?</h1>
               
                <p className="signout__text">
                    You are about to secure your terminal. 
                    You will need to re-authenticate to access <strong>AiPredict</strong> features.
                </p>

                <div className="signout__actions">
                    <button 
                        type="button"
                        className="signout__btn signout__btn--ghost" 
                        onClick={handleCancel}
                        disabled={isLoggingOut}
                    >
                        Cancel
                    </button>
                   
                    <button 
                        type="button"
                        className="signout__btn signout__btn--danger" 
                        onClick={handleConfirm}
                        disabled={isLoggingOut}
                    >
                        {isLoggingOut ? (
                            <>
                                <Icon icon="svg-spinners:ring-resize" style={{marginRight:8}} /> 
                                Terminating...
                            </>
                        ) : (
                            <>
                                <span>Yes, Sign Out</span>
                                <Icon icon="solar:arrow-right-linear" style={{marginLeft:6}} />
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Signout;